import api from '../config/api';

/**
 * Location Service
 * Handles all location-related API calls (cities, districts, states)
 */

/**
 * Search cities with autocomplete
 * @param {Object} params - Query parameters
 * @param {string} params.q - Search query string (required)
 * @param {number} params.limit - Max results (default: 20)
 * @param {number} params.state_id - Filter by state ID
 * @param {number} params.district_id - Filter by district ID
 * @returns {Promise} API response with cities data
 */
export const searchCities = async (params = {}) => {
  try {
    const { q, limit = 20, state_id, district_id } = params;

    if (!q || q.trim().length === 0) {
      return { success: true, data: [] };
    }

    const queryParams = {
      q: q.trim(),
      limit
    };

    if (state_id) queryParams.state_id = state_id;
    if (district_id) queryParams.district_id = district_id;

    const response = await api.get('/api/locations/cities/autocomplete', {
      params: queryParams
    });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'Failed to search cities. Please try again.';
    throw new Error(errorMessage);
  }
};

/**
 * Get city by ID
 * @param {number|string} id - City ID
 * @returns {Promise} API response with city data
 */
export const getCityById = async (id) => {
  try {
    const response = await api.get(`/api/locations/cities/${id}`);
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'Failed to fetch city. Please try again.';
    throw new Error(errorMessage);
  }
};

/**
 * Get all states
 * @returns {Promise} API response with states data
 */
export const getStates = async () => {
  try {
    const response = await api.get('/api/locations/states');
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'Failed to fetch states. Please try again.';
    throw new Error(errorMessage);
  }
};

/**
 * Get districts by state ID
 * @param {number|string} state_id - State ID
 * @returns {Promise} API response with districts data
 */
export const getDistrictsByState = async (state_id) => {
  try {
    console.log(`Calling districts API: GET /api/locations/districts?state_id=${state_id}`);
    const response = await api.get('/api/locations/districts', {
      params: { state_id }
    });
    console.log(`Districts API response for state_id ${state_id}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching districts for state_id ${state_id}:`, error);
    const errorMessage = error.response?.data?.message || 
                        error.response?.data?.error || 
                        error.message || 
                        'Failed to fetch districts. Please try again.';
    throw new Error(errorMessage);
  }
};

